import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"
import SingleTile from "@/components/TilesModule/variants/TilesSquaresGridBackground/SingleTile"
import { getCssSizeValue, getMapKey } from "@/utils/utils"
import GridContainer from "@/components/common/GridContainer"
import styled from "styled-components"
import { insetPaddingLeftCss, insetPaddingRightCss } from "@/styles/globalStyles"

const TilesWrapper = styled(GridContainer)`
	position: relative;
	background: ${({ theme }) => theme.colors.platinum};
	padding: ${getCssSizeValue(48)} 0;
	${insetPaddingLeftCss};
	${insetPaddingRightCss};
`

export default function TilesSquaresGridBackground({ data, paddings, headerDescription }) {
	const tiles = data?.tiles || []

	return (
		<section className={paddings}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			<TilesWrapper>
				{tiles.map((tile, i) => (
					<SingleTile key={getMapKey(tile, i)} tile={tile} />
				))}
			</TilesWrapper>
		</section>
	)
}
